import { FC } from "react";
import { ButtonContainer } from "./button.primary.styled";
import { Props } from "./button.primary.interface";

const ButtonPrimary: FC<Props> = ({
  onClick,
  label,
  name,
  value,
  children,
  styles,
  disabled,
}: Props) => {
  return (
    <ButtonContainer
      onClick={onClick}
      name={name}
      value={value}
      style={styles}
      disabled={disabled}
    >
      <>
     
        {label}
        {children}
      </>
    </ButtonContainer>
  );
};

export default ButtonPrimary;
